import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~/modules/auth/stores/userStore'

export default defineNuxtRouteMiddleware(async () => {
  // skip middleware on server
  if (import.meta.server) return

  const getUserData = async () => {
    const authUserIsLogged = await fetchUserIsLogged()

    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }

  document.addEventListener('GoogleIdentityService:userSignedIn', getUserData)
  await getUserData()

  return
})
